import { FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { ConsumptionFilter, ConsumptionFilterAbstractControls } from './consumption.filter';
import { Injectable } from '@angular/core';
import { ClusterFilterValues, OrganizationFilterValues } from '@shared/services/admin-contract.service';

@Injectable({
  providedIn: 'root',
})
export class ConsumptionFilterFactory {
  public contractInvoicingFilterFormGroup: FormGroup<ConsumptionFilterAbstractControls>;

  constructor(private fb: FormBuilder) {}

  public createContractInvoicingFilterFormGroup = (
    data?: ConsumptionFilter,
    validators?: { [k in keyof ConsumptionFilter]: Array<ValidatorFn> },
  ) => {
    this.contractInvoicingFilterFormGroup = this.fb.group<ConsumptionFilterAbstractControls>({
      organizations: new FormControl<OrganizationFilterValues>(undefined, {
        validators: validators?.['organizations'] ?? [],
      }),
      tags: new FormControl<string>(undefined, { validators: validators?.['tags'] ?? [] }),
      clusters: new FormControl<ClusterFilterValues>(undefined, { validators: validators?.['clusters'] ?? [] }),
    });

    if (data) {
      Object.keys(data).forEach((key: keyof ConsumptionFilter) => this.getFormControl(key).setValue(data[key]));
    }
  };

  public getFormGroup(): FormGroup<ConsumptionFilterAbstractControls> {
    return this.contractInvoicingFilterFormGroup;
  }

  public getFormControl(key: keyof ConsumptionFilter) {
    return this.getFormGroup().get(key) as FormControl;
  }
}
